import React, { useState } from 'react'

const UseSetAllFiles = () => {
    const [Allfiles, setAllFiles] = useState({});
    return {
        Allfiles, setAllFiles
    }
}

export default UseSetAllFiles
